import semver from 'semver'

const permission = {
    install(app) {
        if (this.installed) {
            return
        }

        if (semver.valid(app.version) == null) {
            console.error('Unkown vue version')
            return
        }

        this.installed = true
        if (semver.lt(app.version, '3.0.0')) {
            Object.defineProperties(app.prototype, {
                $permission: {
                    get: function get() {
                        return this.permission
                    }
                }
            })
        } else {

            app.config.globalProperties.$permission = this.permission
        }
        app.$permission = this.permission
    },
    permission(action) {
        return checkPermission(this?.$route?.meta, action)
    },
}

export const checkPermission = (route, action) => {
    return route?.actions?.includes(action)
}
export default permission